
import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import logo from "../../logo.png";
import empty_user from "../../empty_user.png";
import icoTrash from "../../trash.png";


import WallReaded from "./WallReaded";
import WallImageBrowser from "./WallImageBrowser";
import WallLike from "./WallLike";
import WallComment from "./WallComment";

import WallPublish from "./WallPublish";
import WallPublishEdit from "./WallPublishEdit";


import PlTitle from "../../elements/PlTitle";
import VideoPlayer from "./VideoPlayer";
import MediaBrowser from "../../helpers/MediaBrowser";
import ChatWidget from "../msg/ChatWidget";


function Wall(props)
{
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);
    const [lastId, setLastId] = useState(-1);

    const [wallOption, setWallOption] = useState(null);

    const [offset, setOffset] = useState(0);



    useEffect(() => {
        const onScroll = () => setOffset(window.scrollY);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);



    const getWallOption = () => {
        
        props.mainView.setProgress(-2);
    
        var req = {
            
        };

        fetch( Config.url + '/rest_v1_news,wall_option', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       setWallOption(res.result);
                    }
         } )
         .catch(err => {          
                  //  props.mainView.showDialog( "Error", "Iqr34: " + err , "ok" , null);
                    console.log("Iqr34: " + err);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const getData = () => {
        
        props.mainView.setProgress(-2);

        var req = {
            id: lastId,
            ilosc: 4
        };

        fetch( Config.url + '/rest_v1_news,get_news', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        if(lastId == -1) 
                        {
                            setTab(res);     //dodaj na poczatku..

                            props.mainView.writeFilter("wall",  JSON.stringify(res) );
                           

                        }
                        if(lastId > 0 ) //dodaj na koncu.
                        {
                                                                                      
                           
                                var newTab = [ ...tab.result , ...res.result];
                               
                            
                              

                                setTab(
                                    {...tab, [ "result" ]: newTab }
                                );

                      
                        }

                        if(res.result.length >0)
                        {
                         var tmp =  res.result[res.result.length-1].id;
                          setLastId(tmp);
                        }
                    }
         } )
         .catch(err => {          
                   // props.mainView.showDialog( "Error", "Iwqzsqw: " + err , "ok" , null);
                   console.log("Iwqzsqw: " + err );
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const openLink = (e) => {
            var url = e.target.getAttribute("url");
            window.open(url, "_blank");
    }


    const refresh = () => {
        setLastId(-1);
        setTab(null);

        //document.location.reload();
    }

    const checkDel = (e) => {

            var id = e.target.getAttribute('id');

            props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć post?", "yesno", (option)=>{
              
                            ///--------
                            if(option == "yes") goDelete(id);
                            //--------
            } );
    }


    const goDelete = (id) => {
        
        props.mainView.setProgress(-2);

        var req = {
            id: id,         
        };

        fetch( Config.master + '/rest_v1_news,publish_del', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    setLastId(-1)
                    setTab(null);
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    if(wallOption == null)
    {
        setWallOption([]);
        getWallOption();
        return <div></div>
    }


    if(tab == null)
    {
        setTab([]);
        getData(); 


        var tmpWall = props.mainView.readFilter('wall','');
        if(tmpWall.length > 10)
        {
            setTab(  JSON.parse(tmpWall) );
        }


        return (
            <div></div>
        );        
    }

    if(tab._sys_ == undefined) //no correct response..
    {
        return (
            <div></div>
        );   
    }


    if(refreshView != props.userData.refreshView)
    {            
        setRefreshView( props.userData.refreshView);
        setLastId(-1);
        setTab(null);
        getData();

        
    }
 
 

   // console.log(offset + " | " + window.innerHeight); 
 
  

    return (


        <div className="view_content">
         

                    <div className="wall">
            
                    {
                        props.userData.type != "RODZIC" &&
                        <ChatWidget  mainView={props.mainView} userData={props.userData}  view="list" />
                    }    
                    

                    {
                        wallOption.publikowanie == '1' &&
                        <WallPublish   mainView={props.mainView} userData={props.userData} refresh={refresh} />
                    }                    
                    

                    <div className="wall_posts">

                        {
                            tab.result.map( (row, inx) => {
                            

                                var defAwatar =           <img  src={empty_user} />
                            if(row.awatar.length> 10) defAwatar = <img  src={ "data:image/jpeg;base64, " + row.awatar} />


                            var edit = null;
                            var del = null;
                            var optionX = null;


                            if(row.edit == '1') 
                            {
                                edit = <WallPublishEdit   mainView={props.mainView} userData={props.userData} refresh={refresh} row={row} />
                                //del = <span className="link_color" id={row.id}  onClick={checkDel}>usuń</span>
                                del = <img src={icoTrash} className="link_color ico_wall_trash" id={row.id}  onClick={checkDel} />
                            }

                  
                                return (
                                
                                    <div className="item" key={inx}>  

                                                <div className="wall_edit">
                                                    {edit} &nbsp;  {del}  
                                                </div>    
                                            

                                                <div className="item_user">
                                                            {defAwatar}
                                                            <div className="item_title">{row.tytul}    </div>
                                                            <div className="item_date">{row.data}</div>
                                                </div> 

                                            {
                                                row.odczytane != undefined && row.odczytane.length > 0 &&
                                                <WallReaded tab={row.odczytane} />
                                            }
                                           



                                                <div className="item_txt">
                                                    
                                                    <p dangerouslySetInnerHTML={{ __html: row.opis }}></p>
                                                </div>


                                                <div className="item_links">
                                                    {
                                                            row.link.map( (link,ixl) => {

                                                                var imgOp = null;
                                                                if(link.og_img_b64.length > 1)
                                                                {
                                                                    imgOp = <div className="link_img"><img  onClick={openLink} url={link.url}  src={ "data:image/jpeg;base64, " + link.og_img_b64} /> </div>;
                                                                }

                                                                return (
                                                                    <div className="one_link" key={ixl}>
                                                                            <div className="link_url" onClick={openLink} url={link.url} >Idź do: {link.url}</div>
                                                                            {imgOp}
                                                                    </div>
                                                                )
                                                            } )
                                                    }
                                                </div>


                                                


                                                {
                                                    row.zdjecia_m.length > 0 &&
                                                    <Fragment>
                                                        <MediaBrowser userData={props.userData} mainView={props.mainView}  review={row.zdjecia_m[0].merge_base64 } typ="p_wydarzenia" typId={row.id} />
                                                    </Fragment>
                                                }     

                                                {
                                                    row.zdjecia.length > 0 &&   row.zdjecia_m.length <= 0 &&
                                                    <Fragment>
                                                        <MediaBrowser userData={props.userData} mainView={props.mainView}  review={row.zdjecia[0].base64 } typ="p_wydarzenia" typId={row.id} />
                                                    </Fragment>
                                                }       
                                                
                                                {
                                                     row.zdjecia.length == 0 &&   row.zdjecia_m.length == 0 &&  row.video.length > 0 &&
                                                     <Fragment>
                                                         <MediaBrowser userData={props.userData} mainView={props.mainView}  review={ row.video[0].video_shot } typ="p_wydarzenia" typId={row.id} />
                                                     </Fragment>
                                                }
                                            
                                                <div>
                                                    
                                                    {
                                                        row.pliki.map(  (pp, inx) => {

                                                            return <a href={pp.link} key={inx} target="_blank" className="link_color">
                                                                {pp.nazwa} 
                                                            </a>

                                                        } )
                                                    }
                                                 
                                                {
                                                    row.pliki.length > 0 &&
                                                    <Fragment>
                                                           <br/>&nbsp;<br/>
                                                    </Fragment>
                                                }

                                                </div>
                                                
                                                
                                             
                                                  

                                                <WallLike tab={row.like} typ="p_wydarzenia" typId={row.id}  mainView={props.mainView} userData={props.userData} />

                                                {
                                                    row.mozna_komentowac	== 1 &&
                                                    <WallComment tab={row.komentarze} typ="p_wydarzenia" typId={row.id}  mainView={props.mainView} userData={props.userData} />
                                                }                                                       
 


                                            
                                        </div>

                                    
                                    
                                )


                            } )

                        }
                            

                        <div onClick={getData} className="link_color">załaduj kolejne</div>      

                    </div>
        
                </div>
        </div>

       
    )
}


export default Wall;